import React from "react";
import { useState, useEffect } from "react";
import moment from "moment";
import { UNIVERSAL_SEARCH_URL } from "../../../utils/constants";
export default function UserDetails(props) {
	const [educationalQualification, setEducationalQualification] = useState();

	useEffect(() => {
		let eQ;
		if (
			props.data &&
			Object.keys(props.data).length &&
			props.userData &&
			Object.keys(props.userData).length
		) {
			eQ = props.userData.customer_profile_data.Education.filter(
				(f) =>
					String(f.value) ===
					String(props.data[0]["educational_qualification"])
			);
			console.log("AJCBDB", eQ);

			if (eQ.length > 0) setEducationalQualification(eQ[0].label);
		}
	}, [props.userData, props.data]);
	const renderUserData = () => {
		console.log("user details props", props.data, props.userData);

		let temp = props.data.map((e, index) => {
			return (
				<div>
					<div className="row">
						<div className="col-md-6">
							<a href={UNIVERSAL_SEARCH_URL} target="_blank">
								Go to universal search
							</a>
							<div className="row">
								<div className="col-md-5">
									<span className="ml-30">Name:</span>
								</div>
								<div className="col-md-6">
									<span>
										{`${e["first_name"]} ${e["last_name"]}`}
									</span>
								</div>
							</div>
							<div className="row">
								<div className="col-md-5">
									<span className="ml-30">
										Email address:
									</span>
								</div>
								<div className="col-md-6">
									<span>{`${e["email_address"] ?? ""}`}</span>
								</div>
							</div>
							<div className="row">
								<div className="col-md-5">
									<span className="ml-30">
										Contact Number:
									</span>
								</div>
								<div className="col-md-6">
									<span>{`${e["mobile_number"] ?? ""}`}</span>
								</div>
							</div>
							<div className="row">
								<div className="col-md-5">
									<span className="ml-30">
										Alternate Contact Number:{" "}
									</span>
								</div>
								<div className="col-md-6">
									<span>{`${
										e["alternate_mobile_number"] ?? ""
									}`}</span>
								</div>
							</div>
							{/* asdcasd */}
							<div className="row">
								<div className="col-md-5">
									<span className="ml-30">
										Date of Birth:{" "}
									</span>
								</div>
								<div className="col-md-6">
									<span>
										{moment(e["date_of_birth"]).format(
											"DD/MM/YYYY"
										)}
									</span>
								</div>
							</div>
							<div className="row">
								<div className="col-md-5">
									<span className="ml-30">Gender: </span>
								</div>
								<div className="col-md-6">
									<span>{`${e["gender"] ?? ""}`}</span>
								</div>
							</div>

							<div className="row">
								<div className="col-md-5">
									<span className="ml-30">
										Educational Qualification:{" "}
									</span>
								</div>
								<div className="col-md-6">
									<span>{educationalQualification}</span>
								</div>
							</div>
							<div className="row">
								<div className="col-md-5">
									<span className="ml-30">
										Other Educational Qualification:{" "}
									</span>
								</div>
								<div className="col-md-6">
									<span>{`${
										e["educational_qualification"] === "-1"
											? e["other_qualification"]
											: "-"
									}`}</span>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="row">
								<div className="col-md-5">
									<span className="ml-30">Pincode: </span>
								</div>
								<div className="col-md-6">
									<span>{`${e["pincode"] ?? ""}`}</span>
								</div>
							</div>
							<div className="row">
								<div className="col-md-5">
									<span className="ml-30">City: </span>
								</div>
								<div className="col-md-6">
									<span>{`${e["city"] ?? ""}`}</span>
								</div>
							</div>
							<div className="row">
								<div className="col-md-5">
									<span className="ml-30">State: </span>
								</div>
								<div className="col-md-6">
									<span>{`${e["state"] ?? ""}`}</span>
								</div>
							</div>
							<div className="row">
								<div className="col-md-5">
									<span className="ml-30">Country: </span>
								</div>
								<div className="col-md-6">
									<span>{`${e["country"] ?? ""}`}</span>
								</div>
							</div>
						</div>
					</div>
				</div>


			 



			);
		});
		return (
			<div>
				<div>
					<span>
						<b>{props.label}</b>
					</span>
				</div>

				{temp}
			</div>
		);
	};
	return props.data.length > 0 ? (
		renderUserData()
	) : (
		<div>
			<span>
				<b>{props.label}</b>
				<br></br>
				<a href={UNIVERSAL_SEARCH_URL} target="_blank">
					Go to universal search
				</a>
				<br></br>
				<span>No data found</span>
			</span>
		</div>
	);
}
